import { Navigate } from "react-router-dom";

// Pages each role can access (all others redirect to their allowed home)
const ROLE_ALLOWED = {
  "super-admin":  null,          // null = everything allowed
  "admin":        null,
  "admin-staff":  null,
  "staff":        ["/dashboard", "/listproduct", "/orders"],
  "stock-staff":  ["/stock", "/saree-details", "/saree-barcodes"],
};

const ProtectedRoute = ({ children, path }) => {
  const adminToken = sessionStorage.getItem("adminToken");
  const adminRole  = sessionStorage.getItem("adminRole");

  if (!adminToken) return <Navigate to="/admin/login" />;

  const allowed = ROLE_ALLOWED[adminRole];
  if (allowed !== null && allowed !== undefined && path) {
    const canAccess = allowed.some((p) => path.startsWith(p));
    if (!canAccess) {
      // Redirect to role's default page
      const home = adminRole === "stock-staff" ? "/stock" : "/dashboard";
      return <Navigate to={home} />;
    }
  }

  return children;
};

export default ProtectedRoute;
